import React from 'react'
import { EventApi } from '@fullcalendar/core'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import { INITIAL_EVENTS } from './event-utils'
import { DateClickArg } from '@fullcalendar/interaction'
import { EventContentArg } from '@fullcalendar/core'

interface MiniAppState {
  weekendsVisible: boolean
  currentEvents: EventApi[]
  titleText: string | undefined
  tooltipContent: string
}

export default class MiniApp extends React.Component<{}, MiniAppState> {

  state: MiniAppState = {
    weekendsVisible: true,
    currentEvents: [],
    titleText: '',
    tooltipContent: ''
  }

  calendarRef = React.createRef<FullCalendar>();

  componentDidMount() {
    // Assuming drupalSettings is available globally
    const events = window.drupalSettings?.fullcalendar?.events || INITIAL_EVENTS;
    this.setState({ currentEvents: events });
  }

  handleDatesSet = (arg: any) => {
    this.setState({ titleText: arg.view.title });
  }

  handleTitleClick = () => {
    const calendarApi = this.calendarRef?.current?.getApi();
    const currentDate = calendarApi?.getDate() ?? new Date(); // This ensures the correct start of the visible month
    const activeYear = currentDate?.getFullYear();
    let activeMonth = '01';
    if (currentDate !== null && currentDate !== undefined) {
      activeMonth = String(currentDate.getMonth() + 1).padStart(2, '0');
    }
     // Add leading zero for month
    const calendarUrl = `/calendar?month=${activeYear}-${activeMonth}`;
    window.location.href = calendarUrl;
  }

  handleDateClick = (arg: DateClickArg) => {
    const calendarApi = this.calendarRef.current?.getApi();
    calendarApi?.changeView('dayGridDay', arg.dateStr);
  }

  handleBackToMonthClick = (ev: MouseEvent, element: HTMLElement) => {
    const calendarApi = this.calendarRef.current?.getApi();
    const currentDate = calendarApi?.getDate() ?? new Date();
    calendarApi?.changeView('dayGridMonth', currentDate);
  }

  renderEventContent = (eventContent: EventContentArg) => {
    return (
      <>
        {eventContent.event.title}
      </>
    )
  }

  render() {
    return (
      <div className='fullcalendar-app'>
        <FullCalendar
          ref={this.calendarRef}
          locale='vi'
          plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
          headerToolbar={{
            left: 'prev,customBackToMonth',
            center: 'customTitle',
            right: 'next'
          }}
          customButtons={{
            customTitle: {
              text: this.state.titleText,
              click: this.handleTitleClick,
            },
            customBackToMonth: {
              text: '',
              icon: 'fa fa fa-calendar',
              click: this.handleBackToMonthClick,
            }
          }}
          editable={false}
          selectable={false}
          selectMirror={true}
          dayMaxEvents={true}
          weekends={this.state.weekendsVisible}
          initialEvents={INITIAL_EVENTS}
          datesSet={this.handleDatesSet}
          dateClick={this.handleDateClick}
          eventContent={this.renderEventContent}
          eventOrder='weight'
          showNonCurrentDates={false}
          contentHeight='auto'
        />
      </div>
    )
  }

  handleEvents = (events: []) => {
    this.setState({
      currentEvents: events
    })
  }

}
